import { RatesPeriods } from 'constants/pricingWorkbench';

export const LOCK_TERMS = [
  RatesPeriods.PERIOD_15_DAYS,
  RatesPeriods.PERIOD_30_DAYS,
  RatesPeriods.PERIOD_45_DAYS,
  RatesPeriods.PERIOD_60_DAYS,
  RatesPeriods.PERIOD_90_DAYS,
];

export const RATE_DECIMALS = 3;

export const DEFAULT_LOCK_TERM = RatesPeriods.PERIOD_30_DAYS;

/** Fewest / most programs the Compare tray — and the quote built from it — puts side by side. */
export const MIN_COMPARE = 2;
export const MAX_COMPARE = 3;

/** No programs picked for comparison and the Compare tray closed. */
export const EMPTY_COMPARISON = { isOpen: false, keys: [] };

/** Which view the workbench's single right-side drawer is showing (NONE = closed). */
export const WorkbenchDrawerView = {
  LEAD: 'lead',
  NONE: null,
  PROGRAM: 'program',
  QUOTE: 'quote',
};

/**
 * Pricing-target basis for the per-program rate resolver: PRICE targets a buy price, RATE targets a
 * note rate. Picking a rate in a program's rate grid drives a RATE target; a null target falls back
 * to each program's par/best option.
 */
export const PricingTargetType = {
  PRICE: 'price',
  RATE: 'rate',
};

/**
 * Computes lock expiry date string from a lock term in days.
 * @param {number} lockTermDays
 * @returns {string}
 */
export const getLockExpiry = lockTermDays => {
  const d = new Date();

  d.setDate(d.getDate() + lockTermDays);

  return d.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
};

/**
 * Stacking level for workbench surfaces that must paint over form fields — the open loan finder, the
 * pinned Price Scenario footer, the mobile sticky header. CDS field labels sit at z-index 99, so
 * anything lower lets them bleed through as the fields scroll underneath.
 */
export const ABOVE_CDS_FIELD_LABEL_Z_INDEX = 100;
